import i18n from "@/i18n";
import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";
import {notify} from "@/plugins/notification";


export default {
    namespaced: true,
    state: {
        schedules: [],
        currentSchedulePeriod: {date: null, verbose: null},
    },
    mutations: {
        setSchedules(state, newData) {
            state.schedules = newData;
        },
        setCurrentSchedulePeriod(state, newData) {
            state.currentSchedulePeriod = newData;
        },
    },
    actions: {
        async updateCurrentSchedulePeriod({commit}, data) {
            commit("setCurrentSchedulePeriod", data);
        },
        async getSchedules({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {dateFrom, dateTo} = params;
            const url = `${URLS.MODEL.SCHEDULE.SCHEDULES_URL}?date_from=${dateFrom}&date_to=${dateTo}`;
            const options = {
                method: "GET",
                credentials: "include",
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
            };
            const successfulHandler = (data) => {
                commit("setSchedules", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async updateSchedules({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {existingSchedules, newSchedules} = params;
            const url = URLS.MODEL.SCHEDULE.SCHEDULES_URL;
            const options = {
                method: "PUT",
                credentials: "include",
                headers: {
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    "Content-Type": "application/json",
                    role: personalData.role,
                    companyId: company.companyData?.token,
                },
                body: JSON.stringify({
                    existing: existingSchedules,
                    new: newSchedules,
                }),
            };
            const successfulHandler = (data) => {
                commit("setSchedules", data["schedule_data"]);
                commit("salaryReport/addOrUpdateSalaryReports", data["salary_report_data"], {root: true});
                notify(i18n.global.t("Staff schedule successfully updated"), "black", 3000);
                return {successfully: true};
            };
            const errorHandler = (data) => {
                let detail = null;
                if (Array.isArray(data) && data.length > 0) detail = data[0];
                else if (typeof data?.detail === "string") detail = data.detail;
                if (detail) notify(detail, "red", 5000);
                return {successfully: false, detail};
            };
            return globalMethods.sendRequestToGetJson({url, options, successfulHandler, errorHandler});
        },
    },
};